import React, { useEffect, useState } from 'react';
import clinicService from '../../../../../services/clinic.service';
import Loading from '../../../../common/Loading';
import CustomizationForm from './CustomizationForm';
import { useParams } from 'react-router-dom';
function CustomizationTab() {
    const { clinicId } = useParams();
    const [customization, setCustomization] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        loadCustomization();
    }, [clinicId]);

    const loadCustomization = () => {
        setLoading(true);
        setError(null);
        clinicService
            .getCustomization(clinicId)
            .then((res) => {
                setCustomization(res.data || []);
            })
            .catch(() => {
                setError('Failed to load customization settings.');
                setCustomization([]);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const syncCustomization = (customValue) => {
        setCustomization(customValue);
    };

    const handleSaveComplete = (customValue) => {
        setCustomization(customValue);
        setIsEditing(false);
    };

    const handleCancelEdit = () => {
        setIsEditing(false);
        loadCustomization();
    };

    return (
        <>
            <div className="d-flex align-items-end justify-content-between gap-2 mb-3">
                <div>
                    <h5 className="clinic-customization__title mb-1">
                        <i className="bi bi-house-gear text-primary me-1"></i>
                        Clinic Customization
                    </h5>
                    <p className="text-muted small mb-0">Manage custom key-value options for this clinic.</p>
                </div>
                {!loading && (
                    <button
                        type="button"
                        className={`btn btn-sm ${isEditing ? 'btn-outline-danger' : 'btn-outline-primary'}`}
                        onClick={() => (isEditing ? handleCancelEdit() : setIsEditing(true))}
                    >
                        <i className={`bi ${isEditing ? 'bi-x-lg' : 'bi-pencil'} me-1`}></i>
                        {isEditing ? 'Cancel' : 'Modify'}
                    </button>
                )}
            </div>

            {error && !loading && (
                <div className="alert alert-warning border-0 shadow-sm mb-3">
                    <i className="bi bi-exclamation-triangle me-2"></i>
                    {error}
                </div>
            )}

            {loading ? (
                <Loading />
            ) : isEditing ? (
                <CustomizationForm
                    customization={customization}
                    onDataChange={syncCustomization}
                    onSaveComplete={handleSaveComplete}
                    onCancel={handleCancelEdit}
                />
            ) : (
                <div className="notifications-panel">
                    <div className="notifications-panel__header">
                        <span className="d-flex align-items-center gap-2">
                            <i className="bi bi-sliders"></i>
                            Customization Options
                            <span className="text-muted small fw-normal">
                                ({customization.length} item{customization.length !== 1 ? 's' : ''})
                            </span>
                        </span>
                    </div>
                    <div className="notifications-panel__body">
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover align-middle mb-0 process-queue-table clinic-customization-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '35%' }}>
                                            <i className="bi bi-key"></i> Key
                                        </th>
                                        <th>
                                            <i className="bi bi-receipt"></i> Value
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {customization.length > 0 ? (
                                        customization.map((item) => (
                                            <tr key={item.id} className="clinic-customization-row">
                                                <td>
                                                    <span className="clinic-customization-key">{item.optionKey}</span>
                                                </td>
                                                <td>
                                                    <span className="clinic-customization-value">{item.optionValue}</span>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2" className="p-0 border-0">
                                                <div className="clinic-customization-empty">
                                                    <i className="bi bi-sliders"></i>
                                                    No customization values configured.
                                                    <div className="mt-3">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary btn-sm"
                                                            onClick={() => setIsEditing(true)}
                                                        >
                                                            <i className="bi bi-plus-lg me-1"></i>
                                                            Add First Option
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default CustomizationTab;
